<template>
  <!--
   debitis-blanditiis-et-cupiditate-et-iure-veniam-esse
   تست-محصول-متغییر
   محصول-دو-متغیره
   -->
  <div>
    <m-single-product-wrapper :product-link="productLink" @product="dataReady">
      <template v-slot="{product}">
        <div>
          <div class="container-fluid">
            <div class="container-fluid single-product-302-breadcrumb">
              <div class="col-lg-12">
                <m-a :href="{name:'Home'}">
                  <span class="text-dark breadcrumb-item-size" v-t="`product.single.breadcrumb_home`"></span>
                </m-a>
                /
                <m-a :href="{name:'Products'}">
                  <span class="text-dark breadcrumb-item-size" v-t="`product.single.breadcrumb_product`"></span>
                </m-a>

                <div class="d-inline" v-if="product.brand">
                  /
                  <m-a :href="{name:'Products',query: { page: 1, brand: product.brand.id }}">
                    <span class="text-dark breadcrumb-item-size"> {{ product.brand.name }} </span>
                  </m-a>
                </div>

              </div>
            </div>

            <div class="border-box mt-3 single-product-302-content container-fluid">
              <div class="row m-3">

                <div class="col-lg-6 col-md-6 col-sm-12 single-product-302-content-slider">

                  <single-product-gallery1 :galleryFullSlider="galleryFullSlider" :product="product"/>

                </div>


                <div class="single-product-302-content-description mt-5 col-lg-6 col-md-6 col-sm-12 ">


                  <div class="">

                    <div class="col-12">

                      <h1 class="product-name text-dark font-weight-bold ">{{ product.name }}</h1>
                      <div v-if="product.description != undefined"
                           v-html="processContent(product.description.slice(0,1024))"></div>

                    </div>


                    <div class="row justify-content-center align-items-center ">

                      <div v-if="showLastUpdate" class="col-12">
                        <div class="alert alert-success">
                          <span
                              v-html="$t('product.single.product_updated_at',{product_updated_at:productUpdatedAt(product)})"></span>
                        </div>
                      </div>
                      <m-single-product-price3 :showWhatsAppButtonsMessage="showWhatsAppButtonsMessage"
                                               class="text-center" :product="product"/>

                    </div>


                    <div class="product-left-side-bottom">
                      <div class=" pb-4 category-item">
                        <span v-t="`product.single.category`"></span>
                        <div class="d-inline" v-for="(category,index) in product.category">
                          <m-a :href="{name:'SingleCategory',params:{slug:category.slug}}">
                            <span class="text-dark"> {{ category.name }} </span>
                          </m-a>
                          <span v-if="index < product.category.length-1 ">,</span>
                        </div>
                      </div>
                      <div class=" pb-4 category-item">
                        <span v-t="`product.single.keyword`"></span>
                        <div class="d-inline" v-for="(keyword,index) in product.keywords">
                          <span class="text-dark"> {{ keyword.keyword }} </span>
                          <span v-if="index < product.keywords.length-1 ">,</span>
                        </div>
                      </div>
                      <div v-if="generateInstagram()" class=" pb-4 category-item">
                        <a class="text-decoration-none" target="_blank" :href="generateInstagram()['link']">
                          <div style="width: 48px;height: 48px;" class="d-inline-block">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="100%" height="100%">
                              <radialGradient id="yOrnnhliCrdS2gy~4tD8ma" cx="19.38" cy="42.035" r="44.899"
                                              gradientUnits="userSpaceOnUse">
                                <stop offset="0" stop-color="#fd5"/>
                                <stop offset=".328" stop-color="#ff543f"/>
                                <stop offset=".348" stop-color="#fc5245"/>
                                <stop offset=".504" stop-color="#e64771"/>
                                <stop offset=".643" stop-color="#d53e91"/>
                                <stop offset=".761" stop-color="#cc39a4"/>
                                <stop offset=".841" stop-color="#c837ab"/>
                              </radialGradient>
                              <path fill="url(#yOrnnhliCrdS2gy~4tD8ma)"
                                    d="M34.017,41.99l-20,0.019c-4.4,0.004-8.003-3.592-8.008-7.992l-0.019-20	c-0.004-4.4,3.592-8.003,7.992-8.008l20-0.019c4.4-0.004,8.003,3.592,8.008,7.992l0.019,20	C42.014,38.383,38.417,41.986,34.017,41.99z"/>
                              <radialGradient id="yOrnnhliCrdS2gy~4tD8mb" cx="11.786" cy="5.54" r="29.813"
                                              gradientTransform="matrix(1 0 0 .6663 0 1.849)"
                                              gradientUnits="userSpaceOnUse">
                                <stop offset="0" stop-color="#4168c9"/>
                                <stop offset=".999" stop-color="#4168c9" stop-opacity="0"/>
                              </radialGradient>
                              <path fill="url(#yOrnnhliCrdS2gy~4tD8mb)"
                                    d="M34.017,41.99l-20,0.019c-4.4,0.004-8.003-3.592-8.008-7.992l-0.019-20	c-0.004-4.4,3.592-8.003,7.992-8.008l20-0.019c4.4-0.004,8.003,3.592,8.008,7.992l0.019,20	C42.014,38.383,38.417,41.986,34.017,41.99z"/>
                              <path fill="#fff"
                                    d="M24,31c-3.859,0-7-3.14-7-7s3.141-7,7-7s7,3.14,7,7S27.859,31,24,31z M24,19c-2.757,0-5,2.243-5,5	s2.243,5,5,5s5-2.243,5-5S26.757,19,24,19z"/>
                              <circle cx="31.5" cy="16.5" r="1.5" fill="#fff"/>
                              <path fill="#fff"
                                    d="M30,37H18c-3.859,0-7-3.14-7-7V18c0-3.86,3.141-7,7-7h12c3.859,0,7,3.14,7,7v12	C37,33.86,33.859,37,30,37z M18,13c-2.757,0-5,2.243-5,5v12c0,2.757,2.243,5,5,5h12c2.757,0,5-2.243,5-5V18c0-2.757-2.243-5-5-5H18z"/>
                            </svg>
                          </div>
                          <div class="d-inline">
                            <span class="text-dark">{{ generateInstagram()['id'] }}@</span>
                          </div>
                        </a>
                      </div>

                      <div class="single-product-302-store-card" v-if="product.user">
                        <m-store-card310 :store="product.user"/>
                      </div>


                    </div>

                  </div>
                </div>


              </div>
            </div>

            <div class="container-fluid single-product-302-detail ">
              <div class=" row mt-3">


                <ul class="nav text-center col-lg-12 nav-pills mb-3" id="pills-tab" role="tablist">
                  <li class="nav-item col" role="presentation">
                    <a class="nav-link active" id="pills-detail-tab" data-toggle="pill" href="#pills-detail" role="tab"
                       aria-controls="pills-detail" aria-selected="true" v-t="`product.single.detail`"></a>
                  </li>
                  <li class="nav-item col" role="presentation">
                    <a class="nav-link" id="pills-description-tab" data-toggle="pill" href="#pills-description"
                       role="tab"
                       aria-controls="pills-description" aria-selected="false" v-t="`product.single.description`"></a>
                  </li>
                  <li class="nav-item col" role="presentation">
                    <a class="nav-link" id="pills-comments-tab" data-toggle="pill" href="#pills-comments"
                       role="tab"
                       aria-controls="pills-description" aria-selected="false" v-t="`product.single.comment`"></a>
                  </li>
                </ul>

                <div class="tab-content col-lg-12" id="pills-tabContent">
                  <div class="tab-pane fade show active" id="pills-detail" role="tabpanel"
                       aria-labelledby="pills-detail-tab">
                    <single-product-table-feature1 :product="product"/>
                  </div>

                  <div class="tab-pane fade border p-1 rounded" id="pills-description" role="tabpanel"
                       aria-labelledby="pills-description-tab" v-html="processContent(product.description)">

                  </div>

                  <div class="tab-pane fade border p-1 rounded" id="pills-comments" role="tabpanel"
                       aria-labelledby="pills-comments-tab">
                    <m-comment-archive-1 commentable_type="product" :commentable_id="product.id"/>
                  </div>
                </div>


              </div>
            </div>
          </div>


          <div v-if="relatedProducts" class="container-fluid single-product-302-suggestion">
            <m-product-slider1 :product-card-name="productCardName" :product-categories="productCategories(product)"
                               :wait-for-category="true"/>
          </div>

          <div v-if="product.courses && relatedCourse" class="container-fluid  single-product-302-courses">
            <h1 class="my-3 text-center" v-t="`product.single.courses`"></h1>
            <div class="row">
              <div class="col-lg-4" v-for="course in product.courses">
                <m-course-card1 :course="course"/>
              </div>
            </div>
          </div>


        </div>
      </template>
    </m-single-product-wrapper>


  </div>
</template>

<script>
import mSingleProductWrapper from "../../Wrappers/SingleProductWrapper";
import mSingleProductPriceWrapper from "../../Product/SingleProductPriceWrapper";
import mH2 from "../../Tags/H2";
import mA from "../../Tags/A";
import mProductPrice100 from "../../Product/ProductPrice100";
import mSingleProductPrice3 from "../SingleProductPrice3/SingleProductPrice3";
import mProductSlider1 from "../ProductSlider/ProductSlider1";
import mCourseCard1 from "../../Course/Card/CourseCard1";
import mStoreCard310 from "../../MultipleStore/Card/StoreCard310";
import mHtmlToComponentWrapper from "../../Wrappers/HtmlToComponentWrapper";
import {Cards} from "../../Product/Card/Cards";
import SingleProductGallery1 from "./Components/SingleProductGallery1.vue";
import SingleProductTableFeature1 from "./Components/SingleProductTableFeature1.vue";
import mCommentArchive1 from "../../Comment/Archive/CommentArchive1.vue";
import {convertToJalaliWithTime, dateConverter} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";

export default {
  name: "SingleProduct302",
  props: {
    productLink: {
      default: null
    },
    relatedProducts: {
      type: Boolean,
      default: true
    },
    productCardName: {
      options: Object.keys(Cards),
      default: 'mProductCard309',
    },
    relatedCourse: {
      type: Boolean,
      default: false,
    },
    galleryFullSlider: {
      type: Boolean,
      default: false
    },
    showWhatsAppButtonsMessage: {
      default: null
    },
    showLastUpdate: {
      type: Boolean,
      default: false
    }
  },
  components: {
    mCommentArchive1,
    SingleProductTableFeature1,
    SingleProductGallery1,
    mSingleProductWrapper,
    mH2,
    mSingleProductPriceWrapper,
    mProductPrice100,
    mSingleProductPrice3,
    mProductSlider1,
    mA,
    mCourseCard1,
    mStoreCard310,
    mHtmlToComponentWrapper,
  },
  data() {
    return {};
  },
  methods: {
    dataReady(product) {
      this.$emit('product', product)
    },
    productCategories(product) {
      if (product.category != undefined) {
        let categories = product.category.map(item => {
          return item.slug;
        })

        return categories.length == 0 ? null : categories
      }

    },
    productBrands(product) {
      const brand = product.brand;
      return brand == null ? null : [brand.slug];
    },
    generateInstagram() {
      const instagrams = this.findAttributeOnSiteInfo('social_media_instagram');
      if (instagrams.length > 0) {
        let instagram = instagrams[0];
        let instagramLink = instagram;

        instagram = instagram.split('/');
        // remove empty element
        instagram = instagram.filter(function (el) {
          return el != '';
        });

        return {'link': instagramLink, 'id': instagram.slice(-1)[0]}
      }
      return false;
    },
    productUpdatedAt(product) {
      let productUpdatedAt = product.updated_at
      return dateConverter(productUpdatedAt, '/', true)
    }
  },
};
</script>


<style scoped>
.single-product-302-content-description {
  height: fit-content;
  padding: 10px;
}

.single-product-302-content-description :deep(video) {
  max-width: 100%;
}

.product-name {
  font-size: 30px;
}

.breadcrumb-item-size {
  font-size: 14px;
  color: #19bfd3 !important;
}

.category-item * {
  color: black !important;
}

.product-left-side-bottom {
  margin: 30px 20px;
  border-top: 1px solid rgb(0 0 0 / 14%);
  padding-top: 10px;
  font-size: 13px;
}

.border-box {
  border: 1px solid var(--primary);
  border-radius: 8px;
}


</style>